import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// estilos
import "../../assets/style/componentPrincipal.css";
import "./pptosNew.css";

import "../../assets/style/tablesG.css";

// componentes
import { Buscar } from "../general/buscadorNegocios/Buscar";
import { Crear } from "../general/crear/Crear";
import { ExportExcelNegocios } from "../general/exportarPlanilla/ExportExcelNegocios";

import { usePptos } from "../../hooks/usePptos";

// redux
import {
  iniCargarNegocios,
  budgetsSetFiltersList,
} from "../../redux/actions/pptos";
import { VerReporte } from "../general/verReporte/VerReporte";
import { TableListAprobados } from "../tables/TableListAprobados";
import { SlidersHorizontal, TrendingUp, Wallet } from "lucide-react";
import { Tooltip } from "@mui/material";
import { TableListAprobadosModoFlujo } from "../tables/TableListAprobadosModoFlujo";
import { DateFilters } from "./list/DateFilters";

export const PptosListaAprobados = () => {
  const { initExportNegocios } = usePptos();

  const { access, perfil } = useSelector((state) => state.auth);
  const filtersDefaultDate = useSelector((state) => state.ppto.ppto_filters);
  const [showFilters, setShowFilters] = useState(false);
  const [viewMode, setViewMode] = useState("caja");

  const dispatch = useDispatch();
  const [filters, setFiltersState] = useState({
    time: filtersDefaultDate?.time || "all",
    estado: "aprobado",
    check_proceso: true,
    check_standby: false,
    check_cerrada: false,
    text: "",
    fecha_desde: filtersDefaultDate?.fecha_desde || new Date(),
    fecha_hasta: filtersDefaultDate?.fecha_hasta || new Date(),
    abierto_compras: false,
    cerrado_compras: false,
    facturado: false,
    por_facturar: false,
    id_unit: "",
    id_ejecutivo: "",
    page: 1,
    rows: 10,
    buscar: false,
  });

  const setFilters = next => setFiltersState(previous => {
    const updated = typeof next === 'function' ? next(previous) : next;
    const changed = Object.keys(updated).some(key => !['page','buscar'].includes(key) && String(previous[key]) !== String(updated[key]));
    return {...updated,page:changed ? 1 : updated.page};
  });

  useEffect(() => {
    const controller = new AbortController();
    dispatch(iniCargarNegocios(filters, {signal:controller.signal}));
    return () => controller.abort();
  }, [dispatch, filters]);

  useEffect(() => {
    if (filters?.buscar === true) {
      dispatch(
        budgetsSetFiltersList({
          time: filters?.time,
          fecha_desde: filters?.fecha_desde,
          fecha_hasta: filters?.fecha_hasta,
        }),
      );
    }
  }, [dispatch, filters]);

  const handleChangeDateDesde = (newValue) => {
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  return (
    <div className="p-container">
      <h1 className="p-title flex items-center gap-2">
        <span>Proyectos</span>
        <Tooltip title="Mostrar opciones de búsqueda">
          <button onClick={() => setShowFilters(!showFilters)}>
            <SlidersHorizontal className="w-4 h-4 mt-1" />
          </button>
        </Tooltip>
      </h1>

      {showFilters && (
        <>
          <DateFilters
            filters={filters}
            setFilters={setFilters}
            handleChangeDateDesde={handleChangeDateDesde}
            handleChangeDateHasta={handleChangeDateHasta}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 p-2">
            <div className="flex">
              <Buscar filters={filters} setFilters={setFilters} />
              {perfil !== 9 && (
                <div className="ms-1 hidden md:block">
                  <Crear />
                </div>
              )}
            </div>

            {perfil !== 9 && (
              <div className="md:flex justify-end hidden">
                <ExportExcelNegocios
                  filters={filters}
                  initExport={initExportNegocios}
                />
                <VerReporte />
              </div>
            )}
          </div>
        </>
      )}

      {perfil !== 9 && (
        <div className="p-box-filters flex justify-between">
          <div className="p-box-filters-items">
            <Link to="/ppto">Presupuestos por aprobar</Link>
            <Link to="/projects" className="selected">
              Proyectos aprobados
            </Link>
            {!access.a25 ? (
              <Link to="/projects/pf">Pendientes por facturar</Link>
            ) : (
              ""
            )}
          </div>
          <div className="flex gap-2">
            <Tooltip title="Vista Rentabilidad">
              <button
                className="me-2"
                onClick={() => setViewMode("rentabilidad")}
              >
                <TrendingUp
                  size={20}
                  color={`${viewMode === "rentabilidad" ? "#8E24AA" : "gray"}`}
                />
              </button>
            </Tooltip>
            <Tooltip title="Vista Caja">
              <button className="me-2" onClick={() => setViewMode("caja")}>
                <Wallet
                  size={20}
                  color={`${viewMode === "caja" ? "#8E24AA" : "gray"}`}
                />
              </button>
            </Tooltip>
          </div>
        </div>
      )}

      {viewMode === "caja" ? (
        <TableListAprobadosModoFlujo
          filters={filters}
          setFilters={setFilters}
        />
      ) : (
        <TableListAprobados filters={filters} setFilters={setFilters} />
      )}
    </div>
  );
};
